export default {
  init() {
    (function() {
      var spaceStaticHeader = function() {
        var $fixedHeader = $(".header-fixed");
        var $transHeader = $(".header-fixed--transparent");
        if($fixedHeader.length > 0 && $transHeader.length == 0) {
          var topMargin = $fixedHeader.height();
          $(".main").css({
            'margin-top': topMargin + 'px',
          });
        }
      };
      spaceStaticHeader();
      $(window).resize(spaceStaticHeader);
      var checkStaticHeader = function() {
          var $fixedHeader = $(".header-fixed");
          if(!$fixedHeader.hasClass("header-fixed--active")) {
              if($(window).scrollTop() !== 0) {
                  $fixedHeader.addClass("header-fixed--active");
              }
          }
      }
      checkStaticHeader();
    })();

    // JavaScript to be fired on all pages
    $(".js-more-service-areas").each(function(){
        $(this).click(function(){
            $(".js-area-hidden").each(function(){
                $(this).toggleClass('display-none');
            });
        });
    });

    $(".service-sidebar__cat").each(function(){
        var $this = $(this);
        var button = $(this).find('.js-services-sidebar-toggle');
        $(button).click(function(){
            $(this).toggleClass('services-sidebar__cat-title--expanded')
            $this.find(".js-services-sidebar__list").toggle();
        });
    });

    $(".js-show-resources").each(function(){
        $(this).click(function(){
          var $button = $(this);
          $(".js-helpful-resources").toggle( "fast", function() {
            if($('.js-helpful-resources').css('display') == 'none'){
              $button.text('View More')
            } else {
              $button.text('View Less')
            }
          });
        });
    });

    $(".js-matchheight").matchHeight();
    $(".js-home-services").matchHeight();
    $(".js-services-box-image").matchHeight();
    $(".js-review-slider").slick({
      autoplay: true,
      autoplaySpeed: 8000,
      prevArrow: "<span class='arrows arrows--prev'></span>",
      nextArrow: "<span class='arrows arrows--next'></span>",
    });
    $(".js-footer-badges").slick({
      autoplay: true,
      autoplaySpeed: 8000,
      slidesToShow: 5,
      arrows: false,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
    });

    $(".main-menu__item").each(function(){
        var $menu = $(this).find(".main-menu__item__menu");
        if($menu.length > 0) {
            $(this).hover(
                function(){
                    $menu.addClass("main-menu__item__menu--shown");
                },
                function(){
                    $menu.removeClass("main-menu__item__menu--shown");
                }
            );
        }
    });

    $(".top-menu__item").each(function(){
        var $menu = $(this).find(".top-menu__item__menu");
        if($menu.length > 0) {
            $(this).hover(
                function(){
                    $menu.addClass("top-menu__item__menu--shown");
                },
                function(){
                    $menu.removeClass("top-menu__item__menu--shown");
                }
            );
        }
    });

    // $(".js-request-button").each(function() {
    //
    //     var _ = this;
    //     var href = $(this).attr('href');
    //     $(_).magnificPopup({
    //       items: {
    //         src: href,
    //         type: 'inline',
    //         midClick: true,
    //       },
    //     });
    // });

    $(window).on('hashchange', function() {

        var data = JSON.parse($(".js-modal-options").text());
        var hash = window.location.hash;
        console.log()
        var dataLink = data.find(function(item) { return hash === ("#" + item.link); });
        if(dataLink){
          $.magnificPopup.open({
            items: {
              src: '#modal-' + dataLink.link,
              type: 'inline',
            },
            callbacks: {
              open: function() {
                // Will fire when this exact popup is opened
                // this - is Magnific Popup object
              },
              close: function() {
                history.replaceState(null, null, ' ');
              },
              // e.t.c.
            },
          });
        }

    });

    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if (scroll > 0) {
            $(".header-fixed").addClass("header-fixed--active");
        }
        else {
            $(".header-fixed").removeClass("header-fixed--active");
        }
    });

    $(".main-header__right__mobile, .drawer-nav__close-button, .drawer-nav__background").click(function() {
        $(".drawer-nav").toggleClass("drawer-nav--shown");
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js